export default __webpack_public_path__ + "static/media/Material_Subsidiaries_2.60c8a2cb.pdf";